import React,{useEffect,useState} from 'react'
import clinicService from '../../services/clinic.service';
import SocialLink from './SocialLink';
const FeedbackSat = ({clinic,patientID,patientUUID}) => {

    const [clinicLinks,setClinicLinks] = useState()
    useEffect(()=>{
        //get the links and design the boxes
        clinicService.getLinks(clinic.ID)
        .then(res=>{
               // console.log(res.data)
                setClinicLinks(res.data)
        })
        .catch(err=>{
            console.log(err)
        })
    },[])
    return ( 
        <>
            {clinicLinks && 
                 <div className="container mt-4">
                     <div className="row justify-content-center">
                         <div className="col-md-8">
                            <div className="card border-light text-bg-light text-center">
                                 <div className="card-body">
                                     <h4 className="m-3">Thank you! </h4>
                                     <p className="card-text"> We would appreciate if you took a few moments to share your experience with others by writing an online review. </p>
                                     <p className="card-text"> Your vote of confidence is much appreciated and will help other patients make informed decisions.</p>
                                     <div className="row justify-content-center">
                                        {clinicLinks.map((clin)=>(
                                            <SocialLink socialLink={clin} key={clin.ID}/>
                                        ))}
                                     </div>
                                 </div>
                             </div>
                         </div>
                    </div>
                </div>
            
            }
        </>
     );
}
 
export default FeedbackSat;